module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t('label_add_category_membership')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "foo"
  }, _vm._l((_vm.kits), function(k, index) {
    return _c('li', [_c('a', {
      staticClass: "btn-rotate section-title"
    }, [_c('p', [_vm._v(" " + _vm._s(k))]), _vm._v(" "), _c('i', {
      staticClass: "ti-trash clickable",
      on: {
        "click": function($event) {
          return _vm.deleteKit(k)
        }
      }
    })])])
  }), 0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "foo"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newKit),
      expression: "newKit"
    }],
    staticClass: "input width-half",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_insert_name_category_membership'),
      "name": "Dodaj novu opremu"
    },
    domProps: {
      "value": (_vm.newKit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newKit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.addNewKit()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus section-title-clickable"
  })])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "new-button",
    on: {
      "click": function($event) {
        return _vm.updateAdditionalKits()
      }
    }
  }, [_c('i', {
    staticClass: "ti-save"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_save')) + "\n      ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40a54f12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Membership/AddMembershipCategory.vue
// module id = 768
// module chunks = 0